"use strict";
var floatingTableHeader;
(function (floatingTableHeader) {
    /**
     * Error message when given an incorrect type for associatedDataTableObject
     */
    floatingTableHeader.ErrorWrongTypeForAssociatedDataTableObject = "Unsupported type provided for the 'associatedDataTableObject' parameter.";
    /**
     * Error message when the number of headers doesn't match the number of cells
     */
    // tslint:disable-next-line: max-line-length
    floatingTableHeader.ErrorHeaderAndCellCountMismatch = "The number of headers and cells elements must match between the target header table and source data table, headers count: {0}, cells count: {1}.";
    /**
     * Error message when the MeasureMode plugin is missing.
     */
    floatingTableHeader.ErrorMeasureModePluginMissing = "The measure plugin (enterMeasureMode and leaveMeasureMode functions) is required by the floatingTableHeader plugin.";
    /**
     * Creates a wrapper around the contents of the provided headers.
     * This is to be called via jQuery.each which passes each header element
     * via the "this" object.
     */
    function createWrapperIfNecessary() {
        var wrapperObject = jQuery("> .columnHeaderWrapper", this);
        if (wrapperObject.length === 0) {
            var that = jQuery(this);
            var oldContents = that.contents();
            var newWrapper = jQuery("<div class='columnHeaderWrapper'/>").resizable({
                handles: "e",
                zIndex: "auto",
            });
            that.append(newWrapper);
            newWrapper.append(oldContents);
        }
    }
    floatingTableHeader.createWrapperIfNecessary = createWrapperIfNecessary;
    jQuery.fn.extend({
        /**
         * Applies layout to a floating Table header.
         * A Table header is considered floating if it is
         * external to the maintain data table and therefore independent from
         * vertical data scrolling.
         * @param associatedDataTableObject The Table element acting as the data table.
         * @return The jQuery extension for the Floating Table Header.
         */
        layoutFloatingTableHeader: function (associatedDataTableObject) {
            if (associatedDataTableObject && associatedDataTableObject.length === 1) {
                if ($dyn.debug.gridLayout) {
                    document.body.classList.remove("debugGridLayout");
                }
                var useVisibleSelector_1 = (!associatedDataTableObject[0].hasAttribute("data-dyn-isTable"));
                var lastListItem = $("> * > .listItem", associatedDataTableObject).last();
                var dataTableColumnsSelector = "> .listCell:not(.repeater-template,.overlayhost)";
                if (useVisibleSelector_1) {
                    dataTableColumnsSelector += ":visible";
                }
                var dataTableColumns_1 = jQuery(dataTableColumnsSelector, lastListItem);
                var computeColumnWidth_1 = (function () {
                    var cachedColumnWidth = [];
                    return function (columnIndex) {
                        if (cachedColumnWidth[columnIndex] === undefined) {
                            cachedColumnWidth[columnIndex] = dataTableColumns_1[columnIndex].clientWidth;
                        }
                        return cachedColumnWidth[columnIndex];
                    };
                })();
                var applyWidth_1 = function (index, headerCell) {
                    var explicitColumnWidth = headerCell.attr("data-dyn-explicitcolumnwidth");
                    var explicitColumnWidthAsInteger = parseInt(explicitColumnWidth, 10);
                    if (isNaN(explicitColumnWidthAsInteger)) {
                        if (!$dyn || !$dyn.layout.sizing.isDiscreteSize(explicitColumnWidth)) {
                            // This isn't a discrete size like xsmall, small, medium or large,
                            // so we need to calculate the width.
                            jQuery("> .columnHeaderWrapper", headerCell).width(computeColumnWidth_1(index));
                            if ($dyn.debug.gridLayout) {
                                var thCssWidth = jQuery(headerCell).css("width");
                                var columnCssWidth = jQuery(dataTableColumns_1[index]).css("width");
                                $dyn.debug.gridLayout && $dyn.log('Grid: header layout: column - index: %s, header width: %s, column width: %s, calculated, %c %s:"%s"', index, thCssWidth, columnCssWidth, thCssWidth !== columnCssWidth ? "background-color:red" : "", dataTableColumns_1[index].getAttribute("data-dyn-controlname"), headerCell.text().trim());
                            }
                        }
                        else {
                            jQuery("> .columnHeaderWrapper", headerCell).width("");
                            if ($dyn.debug.gridLayout) {
                                var thCssWidth = jQuery(headerCell).css("width");
                                var columnCssWidth = jQuery(dataTableColumns_1[index]).css("width");
                                $dyn.log('Grid: header layout: column - index: %s, header width: %s column width: %s, discrete(%s),%c %s:"%s""', index, thCssWidth, columnCssWidth, explicitColumnWidth, thCssWidth !== columnCssWidth ? "background-color:red" : "", dataTableColumns_1[index].getAttribute("data-dyn-controlname"), headerCell.text().trim());
                            }
                        }
                    }
                    else {
                        // A hard-coded pixel value has been specified. Use that directly as
                        // taking the width measurement is expensive.
                        jQuery("> .columnHeaderWrapper", headerCell).width(explicitColumnWidthAsInteger);
                        if ($dyn.debug.gridLayout) {
                            var thCssWidth = jQuery(headerCell).css("width");
                            var columnCssWidth = jQuery(dataTableColumns_1[index]).css("width");
                            $dyn.log('Grid: header layout: column - index: %s, header width: %s, column width: %s, explicit(%s), %c %s:"%s""', index, thCssWidth, columnCssWidth, explicitColumnWidthAsInteger, explicitColumnWidth, thCssWidth !== columnCssWidth ? "background-color:red" : "", dataTableColumns_1[index].getAttribute("data-dyn-controlname"), headerCell.text().trim());
                        }
                    }
                };
                jQuery.each(this, function () {
                    // Only may be called on table elements acting as floating table headers.
                    var headerCellsSelector = ".columnHeader:not(.repeater-template)";
                    if (useVisibleSelector_1) {
                        headerCellsSelector += ":visible";
                    }
                    var headerCells = jQuery(headerCellsSelector, jQuery(this));
                    if (headerCells.length === dataTableColumns_1.length) {
                        // Add a special wrapper div that allows size to be dictated within the header.
                        jQuery.each(headerCells, floatingTableHeader.createWrapperIfNecessary);
                        // we are not using an arrow function because on the .each the this context is the cell
                        jQuery.each(headerCells, function (index) {
                            applyWidth_1(parseInt(index, 10), jQuery(this));
                        });
                        associatedDataTableObject.attr("data-dyn-headerstate", "layout-complete");
                    }
                    else if (dataTableColumns_1.length !== 0) {
                        associatedDataTableObject.attr("data-dyn-headerstate", "render-error");
                        $dyn.logError($dyn.format(floatingTableHeader.ErrorHeaderAndCellCountMismatch, headerCells.length, dataTableColumns_1.length));
                        if ($dyn.debug.general) {
                            floatingTableHeader._debugHeaderMismatch(headerCells, associatedDataTableObject);
                        }
                    }
                });
                if ($dyn.debug.gridLayout) {
                    document.body.classList.add("debugGridLayout");
                }
            }
            return this;
        }
    });
    /**
     * Displays the controls names for the header and body to help debug what is missing.
     * @param headerCells The header cells.
     * @param associatedDataTableObject The Table element acting as the data table.
     */
    function _debugHeaderMismatch(headerCells, associatedDataTableObject) {
        $dyn.log("");
        $dyn.log("Headers:");
        headerCells.each(function (index, item) {
            var columnName = item.getAttribute("data-dyn-columnname") || "[anonymous]";
            $dyn.log($dyn.format("{0} {1}", index, columnName));
        });
        $dyn.log("");
        $dyn.log("Cells:");
        var firstListItem = $(".listItem").find(associatedDataTableObject).first();
        $.each($(".listCell", firstListItem), function (index, item) {
            var controlName = "[anonymous]";
            if (item) {
                controlName = item.getAttribute("data-dyn-controlname") || controlName;
                $dyn.log($dyn.format("{0} {1}", index, controlName));
            }
        });
        $dyn.log("");
    }
    floatingTableHeader._debugHeaderMismatch = _debugHeaderMismatch;
})(floatingTableHeader || (floatingTableHeader = {}));

//# sourceMappingURL=floatingTableHeader.js.map
